<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="handling-filter">

    <ul>
        <li>
            <a [attr.class]="totalLocoCountClass" (click)="setSelectedFilter('totalLoco')" href="javascript:void(0)">
                <h2>{{totalLocoRecordCount ? totalLocoRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.totalLoco}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="serviceCenterCountClass" (click)="setSelectedFilter('S')">
                <h2>{{serviceCtrShopRecordCount ? serviceCtrShopRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.serviceCenterShop}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="mainTrackCountClass" (click)="setSelectedFilter('M')">
                <h2>{{mainTrackRecordCount ? mainTrackRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.mainTrack}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="truckFuelCountClass" (click)="setSelectedFilter('T')">
                <h2>{{truckFuelRecordCount ? truckFuelRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.truckFuel}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="storageCountClass" (click)="setSelectedFilter('X')">
                <h2>{{storageRecordCount ? storageRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.storage}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="nextAssignmentCountClass" (click)="setSelectedFilter('nextAssignment')">
                <h2>{{nextAssignmentRecordCount ? nextAssignmentRecordCount : '-'}}</h2>
                <p>{{onTerminalFilterLabel.nextAssignment}}</p>
            </a>
        </li>
    </ul>

</div>
<div class="clear"></div>
<h1>{{onTerminalTable.mainHeader}}</h1>
<div class="table-header handling-tables">
    <div class="column-1">{{onTerminalTable.headerLabel.previousAssignmentLoco}}</div>
    <div class="column-2">{{onTerminalTable.headerLabel.terminalHandlingPlan}}</div>
    <div class="column-3 changed-by-col">{{onTerminalTable.headerLabel.changedBy}}</div>
    <div class="column-4">{{onTerminalTable.headerLabel.actualActivity}}</div>
    <div class="column-5">{{onTerminalTable.headerLabel.plannedAssignment}}</div>
    <div class="column-6 projected-departure-col">{{onTerminalTable.headerLabel.projectedDeparture}}</div>
    <div class="column-7">{{onTerminalTable.headerLabel.previousPlan}}</div>
</div>
<div class="clear"></div>
<div *ngIf="onTerminalLocomotivesArr.length <= 0" class="no-record-found">No record found</div>
<div class="terminal-handling-on-terminal" id="terminal-handling-on-terminal">

   <div class ="scroll-container">
    <div *ngFor="let onTerminalLocomotive of onTerminalLocomotivesArr; let i = index">
            <div *ngIf="onTerminalLocomotive" [ngClass]="{'alt-row-bg': i % 2 === 0}">
                <div class="train-id-date">
                    <p>
                        <a id='{{"outbound" + index + onTerminalLocomotive.previousAssignment}}' href="javascript:void(0)" (click)='redirectToTrainOrTerminal(onTerminalLocomotive.previousAssignment);'
                            (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "outbound" + index + onTerminalLocomotive.previousAssignment, onTerminalLocomotive.previousAssignment);'>
                            <strong>{{onTerminalLocomotive.previousAssignment ? onTerminalLocomotive.previousAssignment : '-'}}</strong>
                        </a>
                    </p>
                </div>
                <div class="table-body handling-tables" *ngFor="let terminalHandlingOnTerminal of onTerminalLocomotive.locomotiveArr; let i = index;">
                    <div class="column-1" id="loco{{terminalHandlingOnTerminal.locomotiveId}}{{i}}">
                        <a class="loco-id-indent" href="javascript:;;" (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(terminalHandlingOnTerminal.locomotiveId, terminalHandlingOnTerminal.actualLocomotiveId, i);'
                            (click)='showLocomotiveTabData("Data", "Locomotive", terminalHandlingOnTerminal.locomotiveId);'>
                            <strong>
                            {{terminalHandlingOnTerminal.locomotiveId ? terminalHandlingOnTerminal.locomotiveId : '-'}}
                            </strong>
                        </a>
                    </div>
                    <div class="column-2" *ngIf="terminalHandlingOnTerminal.terminalHandlingPlan || terminalHandlingOnTerminal.changedBy">
                        {{terminalHandlingOnTerminal.terminalHandlingPlan ? terminalHandlingOnTerminal.terminalHandlingPlan : '-'}}
                        <p class="hidden-1920" *ngIf="terminalHandlingOnTerminal.changedBy">
                            By:
                            <a href="javascript:void(0)" title="{{terminalHandlingOnTerminal.userName? terminalHandlingOnTerminal.userName : ''}}">
                         {{terminalHandlingOnTerminal.changedBy ? terminalHandlingOnTerminal.changedBy : '-'}}
                        </a>
                        </p>
                    </div>
                    <div class="column-2" *ngIf="!terminalHandlingOnTerminal.terminalHandlingPlan && !terminalHandlingOnTerminal.changedBy">
                        -
                    </div>
                    <div class="column-3 changed-by-col">
                        <a href="javascript:void(0)" title="{{terminalHandlingOnTerminal.userName ? terminalHandlingOnTerminal.userName : ''}}">
                    {{terminalHandlingOnTerminal.changedBy ? terminalHandlingOnTerminal.changedBy : '-'}}
                    </a>
                    </div>
                    <div class="column-4" *ngIf="terminalHandlingOnTerminal.actualActivityDesc && terminalHandlingOnTerminal.actualActivityTs">
                        {{terminalHandlingOnTerminal.actualActivityDesc}}
                        <p>
                            {{terminalHandlingOnTerminal.actualActivityTs}}
                        </p>
                    </div>
                    <div class="column-4" *ngIf="(!terminalHandlingOnTerminal.actualActivityDesc && !terminalHandlingOnTerminal.actualActivityTs)">
                        -
                    </div>
                    <div class="column-5" *ngIf="terminalHandlingOnTerminal.plannedAssignment || terminalHandlingOnTerminal.projectedDeparture">
                        <p>
                            <a id='{{"outbound" + index + onTerminalLocomotive.previousAssignment + terminalHandlingOnTerminal.plannedAssignment}}' href="javascript:void(0)"
                                (click)='redirectToTrainOrTerminal(terminalHandlingOnTerminal.plannedAssignment);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "outbound" + index + onTerminalLocomotive.previousAssignment + terminalHandlingOnTerminal.plannedAssignment, terminalHandlingOnTerminal.plannedAssignment);'>
                                <strong>{{terminalHandlingOnTerminal.plannedAssignment ? terminalHandlingOnTerminal.plannedAssignment : '-'}} 
                            </strong>
                            </a>
                            <strong><span *ngIf="terminalHandlingOnTerminal?.intendedUsageCode" class="{{terminalHandlingOnTerminal?.intendedUsageCode === 'Not Power' ? 'color-red':''}}">({{terminalHandlingOnTerminal?.intendedUsageCode}})</span></strong>
                        </p>
                        <p class="hidden-1920" *ngIf="isEtdDisplay(terminalHandlingOnTerminal.plannedAssignment) && terminalHandlingOnTerminal.projectedDeparture">ETD: {{terminalHandlingOnTerminal.projectedDeparture ? terminalHandlingOnTerminal.projectedDeparture
                            : '-'}}</p>

                    </div>
                    <div class="column-5" *ngIf="!terminalHandlingOnTerminal.plannedAssignment && !terminalHandlingOnTerminal.projectedDeparture">
                        -
                    </div>
                    <div class="column-6 projected-departure-col">
                        {{terminalHandlingOnTerminal.projectedDeparture ? terminalHandlingOnTerminal.projectedDeparture : '-'}}
                    </div>
                    <div class="column-7">
                        {{terminalHandlingOnTerminal.previousPlan ? terminalHandlingOnTerminal.previousPlan : '-'}}
                    </div>
                </div>
            </div>
      </div>
</div>
<!-- <p-dataScroller [value]="onTerminalLocomotivesArr" [rows]="rowsPerPage" [inline]="true" scrollHeight="{{scrollDivHeight}}"
        [lazy]="true" (scroll)='hideLocoContextPanel();' (onLazyLoad)="loadOnTerminalLocomotivesLazy($event)">

        <ng-template let-onTerminalLocomotive let-index="index" pTemplate="item">
            <div *ngIf="onTerminalLocomotive">
                <div class="train-id-date">
                    <p>
                        <a id='{{"outbound" + index + onTerminalLocomotive.previousAssignment}}' href="javascript:void(0)" (click)='redirectToTrainOrTerminal(onTerminalLocomotive.previousAssignment);'
                            (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "outbound" + index + onTerminalLocomotive.previousAssignment, onTerminalLocomotive.previousAssignment);'>
                            <strong>{{onTerminalLocomotive.previousAssignment ? onTerminalLocomotive.previousAssignment : '-'}}</strong>
                        </a>
                    </p>
                </div>
                <div class="table-body handling-tables" *ngFor="let terminalHandlingOnTerminal of onTerminalLocomotive.locomotiveArr; let i = index;">
                    <div class="column-1" id="loco{{terminalHandlingOnTerminal.locomotiveId}}{{i}}">
                        <a class="loco-id-indent" href="javascript:;;" (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(terminalHandlingOnTerminal.locomotiveId, terminalHandlingOnTerminal.actualLocomotiveId, i);'
                            (click)='showLocomotiveTabData("Data", "Locomotive", terminalHandlingOnTerminal.locomotiveId);'>
                            <strong>
                            {{terminalHandlingOnTerminal.locomotiveId ? terminalHandlingOnTerminal.locomotiveId : '-'}}
                            </strong>
                        </a>
                    </div>
                    <div class="column-2" *ngIf="terminalHandlingOnTerminal.terminalHandlingPlan || terminalHandlingOnTerminal.changedBy">
                        {{terminalHandlingOnTerminal.terminalHandlingPlan ? terminalHandlingOnTerminal.terminalHandlingPlan : '-'}}
                        <p class="hidden-1920" *ngIf="terminalHandlingOnTerminal.changedBy">
                            By:
                            <a href="javascript:void(0)" title="{{terminalHandlingOnTerminal.userName? terminalHandlingOnTerminal.userName : ''}}">
                         {{terminalHandlingOnTerminal.changedBy ? terminalHandlingOnTerminal.changedBy : '-'}}
                        </a>
                        </p>
                    </div>
                    <div class="column-2" *ngIf="!terminalHandlingOnTerminal.terminalHandlingPlan && !terminalHandlingOnTerminal.changedBy">
                        -
                    </div>
                    <div class="column-3 changed-by-col">
                        <a href="javascript:void(0)" title="{{terminalHandlingOnTerminal.userName ? terminalHandlingOnTerminal.userName : ''}}">
                    {{terminalHandlingOnTerminal.changedBy ? terminalHandlingOnTerminal.changedBy : '-'}}
                    </a>
                    </div>
                    <div class="column-4" *ngIf="terminalHandlingOnTerminal.actualActivityDesc && terminalHandlingOnTerminal.actualActivityTs">
                        {{terminalHandlingOnTerminal.actualActivityDesc}}
                        <p>
                            {{terminalHandlingOnTerminal.actualActivityTs}}
                        </p>
                    </div>
                    <div class="column-4" *ngIf="(!terminalHandlingOnTerminal.actualActivityDesc && !terminalHandlingOnTerminal.actualActivityTs)">
                        -
                    </div>
                    <div class="column-5" *ngIf="terminalHandlingOnTerminal.plannedAssignment || terminalHandlingOnTerminal.projectedDeparture">
                        <p>
                            <a id='{{"outbound" + index + onTerminalLocomotive.previousAssignment + terminalHandlingOnTerminal.plannedAssignment}}' href="javascript:void(0)"
                                (click)='redirectToTrainOrTerminal(terminalHandlingOnTerminal.plannedAssignment);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "outbound" + index + onTerminalLocomotive.previousAssignment + terminalHandlingOnTerminal.plannedAssignment, terminalHandlingOnTerminal.plannedAssignment);'>
                                <strong>{{terminalHandlingOnTerminal.plannedAssignment ? terminalHandlingOnTerminal.plannedAssignment : '-'}} 
                            </strong>
                            </a>
                            <strong><span *ngIf="terminalHandlingOnTerminal?.intendedUsageCode" class="{{terminalHandlingOnTerminal?.intendedUsageCode === 'Not Power' ? 'color-red':''}}">({{terminalHandlingOnTerminal?.intendedUsageCode}})</span></strong>
                        </p>
                        <p class="hidden-1920" *ngIf="isEtdDisplay(terminalHandlingOnTerminal.plannedAssignment) && terminalHandlingOnTerminal.projectedDeparture">ETD: {{terminalHandlingOnTerminal.projectedDeparture ? terminalHandlingOnTerminal.projectedDeparture
                            : '-'}}</p>

                    </div>
                    <div class="column-5" *ngIf="!terminalHandlingOnTerminal.plannedAssignment && !terminalHandlingOnTerminal.projectedDeparture">
                        -
                    </div>
                    <div class="column-6 projected-departure-col">
                        {{terminalHandlingOnTerminal.projectedDeparture ? terminalHandlingOnTerminal.projectedDeparture : '-'}}
                    </div>
                    <div class="column-7">
                        {{terminalHandlingOnTerminal.previousPlan ? terminalHandlingOnTerminal.previousPlan : '-'}}
                    </div>
                </div>
            </div>
        </ng-template>
    </p-dataScroller> -->